export enum GearType {
	MANUAL = 'MANUAL',
	AUTOMATIC = 'AUTOMATIC',
	SEMI_AUTOMATIC = 'SEMI_AUTOMATIC',
	SEQUENTIAL = 'SEQUENTIAL',
}
